var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-rating',{attrs:{"value":_vm.value,"empty-icon":"mdi-star-outline","full-icon":"mdi-star","hover":"","length":_vm.length,"color":"yellow darken-3","background-color":"grey darken-1","readonly":""}})}
var staticRenderFns = []

export { render, staticRenderFns }